import axios from 'axios'
import Vue from 'vue'

Vue.prototype.$ajax = axios;
var baseURL = 'https://api-slb.tuoluohuodong.com/api'; //正式
// var baseURL= 'http://192.168.1.131:8080/api';//本地
// var baseURL = 'https://api-dev.tuoluohuodong.com/api';//测试
let Requests = axios.create({

})


Requests.post = function (url, parameters, callback) {
  var url = baseURL + url
  // let token = '';
  // if (localStorage.getItem("userInfo")) {
  //     token = JSON.parse(localStorage.getItem("userInfo")).token
  // }
  // axios.defaults.headers.common["token"] = token;
  axios.post(url, parameters, callback).then(res => {
    callback(res)
  }).catch(err => {
    callback('null', err);
  });
}

Requests.put = function (url, parameters, callback) {
  var url = baseURL + url
  // let token = '';
  // if (localStorage.getItem("userInfo")) {
  //     token = JSON.parse(localStorage.getItem("userInfo")).token
  // }
  // axios.defaults.headers.common["token"] = token;
  axios.put(url, parameters, callback).then(res => {
    callback(res)
  }).catch(err => {
    callback('null', err);
  });
}

Requests.up = function (url, data, callback) {
  console.log('tagsss', '')
  var url = baseURL + url
  let params = new FormData()
  params.append('name', data.name)
  params.append('type', data.type)
  params.append('file', data.file)

  axios.post(url, params, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(res => {
    callback(res)
  }).catch(error => {
    // alert('更新用户数据失败' + error)
  })
}

Requests.get = function (url, data, callback) {
  var url = baseURL + url
  // let token = '';
  // if (localStorage.getItem("userInfo")) {
  //     token = JSON.parse(localStorage.getItem("userInfo")).token
  // }
  // axios.defaults.headers.common["token"] = token;
  axios.get(url, {
    params: data
  }).then(function (response) {
    callback(response.data);
  }).catch(function (err) {
    console.log(err);
  })
}

Requests.delete = function (url, data, callback) {
  var url = baseURL + url
  // let token = '';
  // if (localStorage.getItem("userInfo")) {
  //     token = JSON.parse(localStorage.getItem("userInfo")).token
  // }
  // axios.defaults.headers.common["token"] = token;
  axios.delete(url, {
    params: data
  }).then(function (response) {
    callback(response.data);
  }).catch(function (err) {
    console.log(err);
  })
}

Requests.getExcelBinary = function (url, data, callback) {
  var url = baseURL + url
  // let token = '';
  // if (localStorage.getItem("userInfo")) {
  //     token = JSON.parse(localStorage.getItem("userInfo")).token
  // }
  // axios.defaults.headers.common["token"] = token;
  axios.get(url, {
    params: data,
    responseType: 'arraybuffer'
  }).then(function (response) {
    callback(response.data);
  }).catch(function (err) {
    console.log(err);
  })
}


export default Requests;



// WEBPACK FOOTER //
// ./src/utils/request.js